import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy Publishing tab URL — folded into Summary (2026-10-16). Redirects old links/bookmarks to
 * Summary with the Approval stage pane selected (`?fStage=APPROVAL`), where the decision band,
 * "What ships" and the delivery status now live.
 */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-v2/runs/$runId/approval')({
  beforeLoad: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({
      to: '/catalog-v2/runs/$runId',
      params: { runId: params.runId },
      search: { fStage: 'APPROVAL' },
      replace: true,
    });
  },
});
